import { render, staticRenderFns } from "./PrivacyContractPage.vue?vue&type=template&id=573f4c4f&scoped=true"
import script from "./PrivacyContractPage.vue?vue&type=script&lang=js"
export * from "./PrivacyContractPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573f4c4f",
  null
  
)

export default component.exports